import * as models from "../models";
import { IQueryString } from "../models/environment";
import * as queryString from "query-string";
import { parseValue, parseArray } from "../utils/utils";
import { getViewModeFromString } from "../utils/viewmode";
import { CalendarViewMode } from "../enumerations";

/**
 * Gibt den Host des Terminplaners zurück.
 * @param url Die übergebene URL wird an den Host angehängt und zurückgegeben.
 */
export function getHost(url?: string): string
{
    var host: string[] = [];
    host.push(window.location.origin);

    if (url)
    {
        if (url.charAt(0) === "/")
        {
            host.push(url);
        }
        else
        {
            host.push("/" + url);
        }
    }

    return host.join("");
}

/**
 * Setzt eine neue URL über pushState.
 * @param url
 * @param state
 */
export function setNewLocation(url: string, state: models.IPopstate, replace: boolean = false): void
{
    if (!replace)
        history.pushState(state, "", getHost(url));
    else
        history.replaceState(state, "", getHost(url));
}

/**
 * Ermittelt die momentane URL.
 */
export function getRedirect(url: string): string
{
    var redirect: string = URI.encode(window.location.href);

    if (url != null)
    {
        if (url.indexOf("?") >= 0)
        {
            return url + "&redirect=" + redirect;
        }
        else
        {
            return url + "?redirect=" + redirect;
        }
    }
    else
    {
        return "redirect=" + redirect;
    }
}